import { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import Html from "./html"; 

const ContactUs = () => {
  const searchState = { data: "" }
  const user = useSelector((state) => state.user)
  const [filters, setFilter] = useState({ page: 1, count: 10, search: "" })
  const [data, setData] = useState([])
  const [total, setTotal] = useState(0)
  const history = useNavigate()

  useEffect(() => {
    setFilter({ ...filters, search: searchState.data })
    getContactData({ search: searchState.data }) // Fetching contact submissions
  }, [])

  // Fetch contact submissions
  const getContactData = (p = {}) => {
    loader(true)
    let filter = { ...filters, ...p }
    ApiClient.get("contactUs/listing", filter).then((res) => {
      if (res.success) {
        setData(res?.data)
        setTotal(res.total)
      }
      loader(false)
    })
  }

  const clear = () => {
    let f = { search: "", status: "" };
    setFilter({ ...filters, ...f });
    getContactData({ ...f }); // Clear contact data as well
  }

  const filter = (p = {}) => {
    let f = { ...p };
    setFilter({ ...filters, ...f });
    getContactData({ ...f });
  }

  const deleteContact = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete this contact us request?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        loader(true);
        ApiClient.delete(`contactUs/delete?id=${id}`).then((res) => {
          if (res.success) {
            clear();
          }
          loader(false);
        });
      }
    });
  }

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    getContactData({ page: e });
  }
  const view = (id) => {
    let url = `detail/${id}`; 
    history(url);
  }
  const count = (e) => {
    setFilter({ ...filters, count: e });
    getContactData({ ...filters, count: e });
  }

  const changestatus = (e, key) => {
    setFilter({ ...filters, [key]: e });
    getContactData({ [key]: e });
  }
  
  const statusChange = (itm) => {
    if (itm.status === "read") return; 
    const newStatus = itm.status=== "read" ? "unread" : "read";
  
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${newStatus === "read" ? "mark as read" : "mark as unread"} this contact submission?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        loader(true); 
        ApiClient.put("contactUs/status/change", { id: itm?._id || itm?.id, status: newStatus })
          .then((res) => {
            if (res.success) {
              getContactData({})
            }
            loader(false); 
          })
          .catch((error) => {
            loader(false);
            console.error("Error updating status:", error);
          });
      }
    });
  };
  
 

  const isAllow = (key = "") => {
    if (user?.role?.name == "admin") return true
    let permissions = user.Permission;
    let value = permissions?.[key];
    return value;
  }

  const handleSearch = (e) => {
    setFilter({ ...filters, search: e.target.value });
    if (e.target.value === "") {
      getContactData({ search: "" })
    }
  }

  return (
    <>
      <Html
        view={view}
        clear={clear}
        isAllow={isAllow}
        count={count}
        pageChange={pageChange}
        deleteContact={deleteContact} 
        filters={filters}
        setFilter={setFilter}
        filter={filter}
        data={data}
        total={total}
        statusChange={statusChange}
        changestatus={changestatus}
        handleSearch={handleSearch}
      />
    </>
  );
};

export default ContactUs;
